import { typeCreatorV2 } from 'redux/utils/common';

//  [REDUCER][TYPE]
export const SET_SAVED_SEARCHES: string = typeCreatorV2(
  'ClientSavedSearchesReducer',
  'SetSavedSearchesData'
);

export const DELETE_SAVED_SEARCH: string = typeCreatorV2(
  'ClientSavedSearchesReducer',
  'DeleteSavedSearch'
);
